import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import { useEffect, useState } from 'react';

/*
To access the feature flags, you need to use the useFlags hook. For example:
import { useFlags } from 'launchdarkly-react-client-sdk';
const { test1 } = useFlags();

if (test1) {
  console.log('test1 is true');
} else {
  console.log('test1 is false');
}

The feature flag already knows the user and the organization because it is defined in the user-info-provider.tsx file.
*/

export const FeatureFlagProvider = ({ children }: { children: React.ReactNode }) => {
  const [Provider, setProvider] = useState<React.ComponentType<{ children: React.ReactNode }>>(() =>
    // This returns a no-op provider when VITE_LAUNCH_DARKLY_CLIENT_ID is not set
    ({ children }: { children: React.ReactNode }) => <>{children}</>,
  );

  useEffect(() => {
    const init = async () => {
      if (import.meta.env.VITE_LAUNCH_DARKLY_CLIENT_ID) {
        const LDProvider = await asyncWithLDProvider({
          clientSideID: import.meta.env.VITE_LAUNCH_DARKLY_CLIENT_ID,
        });
        setProvider(() => LDProvider);
      }
    };
    init();
  }, []);

  return <Provider>{children}</Provider>;
};
